import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import WhatIfWizardCollectionStepperTemplate
  from 'Views/Page/Content/Modal/Layouts/WhatIfWizardCollectionStepperTemplate';
import Layout from './Layout';

const styles = () => ({
  root: {},
});

const StartEndAndMonths = ({
  className,
  classes,
}) => {
  const { metaOverrideSet } = useMetaLayoutContext();
  const { modalCollection } = useModalContext();

  return (
    <WhatIfWizardCollectionStepperTemplate
      className={classNames(className, classes.root)}
      layout={Layout}
      collection={modalCollection}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

StartEndAndMonths.defaultProps = {
  className: '',
};

StartEndAndMonths.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(StartEndAndMonths);
